<template>
  <div>
    <v-btn
      v-if="canApprove"
      class="mr-3 px-6 text-capitalize"
      color="primary"
      flat
      :loading="loading"
      @click="emit('approved')"
      >Approve</v-btn
    >

    <ChitActionsMenuBtn
      :use-full-btn="true"
      :disabled="loading"
      @export-chit-pdf-pressed="emit('export-chit-pdf-pressed')"
      @edit-chit-pressed="emit('edit-chit-pressed')"
      @delete-chit-pressed="emit('delete-chit-pressed')"
    />
  </div>
</template>

<script setup lang="ts">
import ChitActionsMenuBtn from '../ChitActionsMenuBtn.vue'

interface Props {
  canApprove: boolean
  loading?: boolean
}
defineProps<Props>()

interface Emit {
  (e: 'export-chit-pdf-pressed'): void
  (e: 'approved'): void
  (e: 'edit-chit-pressed'): void
  (e: 'delete-chit-pressed'): void
}
const emit = defineEmits<Emit>()
</script>
